import { render, staticRenderFns } from "./goodInfo.vue?vue&type=template&id=398b730e&scoped=true&"
import script from "./goodInfo.vue?vue&type=script&lang=js&"
export * from "./goodInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398b730e",
  null
  
)

export default component.exports